import { AVProject } from "../types/entities"

export const validateProjectInputs = (project: AVProject): string | undefined => {
  if (!project.ProjectCode) {
    return 'Please enter a project code'
  }
  if (project.ProjectType === 'Sales') {
    if (project.UnitType === null) {
      return `Please choose a unit type`
    }
    if (project.ExpensesReimbursed === null) {
      return `Please choose if expenses are reimbursed`
    }
    if (project.TravelReimbursed === null) {
      return `Please choose if travel (km) is reimbursed`
    }
    if (project.ExpensesDeductible === null) {
      return `Please choose if other expenses are deductible`
    }
    if (project.TravelDeductible === null) {
      return `Please choose if travel (km) is deductible`
    }
    if (project.TravelExpensesDeductible === null) {
      return `Please choose if travel expenses are deductible`
    }
    if (project.PaidLeave === null) {
      return `Please choose if paid leave is enabled`
    }
    if (project.CutoffPoint === null) {
      return `Please choose a cutoff point`
    }
    if (project.Supplier === null) {
      return `Please choose a supplier`
    }
  }

  return undefined
}